// ============================================================
// Consumable Definitions — Merchant Shop Items
// ============================================================
export const CONSUMABLE_DEFS = [
    // Token consumables — tokens are rare, prices are steep
    {
        id: 'potion_haste',
        name: 'Potion of Haste',
        description: '+30% attack speed & crit chance for 10 waves',
        icon: '⚡',
        spriteKey: 'con_potion_haste',
        durationWaves: 10,
        price: 13,
        currency: 'tokens',
        rarity: 'rare',
    },
    {
        id: 'potion_resurrect',
        name: 'Talisman of Rebirth',
        description: 'Auto-revives the next fallen hero at 50% HP (one use)',
        icon: '🔮',
        spriteKey: 'con_potion_resurrect',
        durationWaves: 999,
        price: 22,
        currency: 'tokens',
        rarity: 'epic',
    },
    {
        id: 'scroll_power',
        name: 'Scroll of Power',
        description: '+25% damage for 15 waves',
        icon: '📜',
        spriteKey: 'con_scroll_power',
        durationWaves: 15,
        price: 10,
        currency: 'tokens',
        rarity: 'rare',
    },
    {
        id: 'potion_regen',
        name: 'Potion of Regeneration',
        description: 'Steady HP regen for 20 waves — stronger as your heroes grow.',
        icon: '🧪',
        spriteKey: 'con_potion_regen',
        durationWaves: 20,
        price: 15,
        currency: 'tokens',
        rarity: 'rare',
    },
    {
        id: 'elixir_fortitude',
        name: 'Elixir of Fortitude',
        description: '+50% max HP for 15 waves',
        icon: '🛡️',
        spriteKey: 'con_elixir_fortitude',
        durationWaves: 15,
        price: 5,
        currency: 'tokens',
        rarity: 'uncommon',
    },
    {
        id: 'crystal_foresight',
        name: 'Pendant of Foresight',
        description: 'Double book drop chance for 10 waves',
        icon: '🫧',
        spriteKey: 'con_crystal_foresight',
        durationWaves: 10,
        price: 20,
        currency: 'tokens',
        rarity: 'epic',
    },
    {
        id: 'merchant_blessing',
        name: "Merchant's Blessing",
        description: '+100% gold earned for 10 waves',
        icon: '💰',
        spriteKey: 'con_merchant_blessing',
        durationWaves: 10,
        price: 15,
        currency: 'tokens',
        rarity: 'epic',
    },
    // ── New consumables ──
    {
        id: 'potion_vitality',
        name: 'Potion of Vitality',
        description: 'Instantly restores 40% max HP to all heroes',
        icon: '🫧',
        spriteKey: 'con_potion_vitality',
        durationWaves: 1,
        price: 5,
        currency: 'tokens',
        rarity: 'uncommon',
    },
    {
        id: 'potion_mana',
        name: 'Potion of Mana',
        description: 'Instantly restores 40% max Mana to all heroes',
        icon: '💧',
        spriteKey: 'con_potion_mana',
        durationWaves: 1,
        price: 5,
        currency: 'tokens',
        rarity: 'uncommon',
    },
    {
        id: 'elixir_resistance',
        name: 'Elixir of Resistance',
        description: '+20% all resistances for 5 waves',
        icon: '🔰',
        spriteKey: 'con_elixir_resistance',
        durationWaves: 5,
        price: 30,
        currency: 'tokens',
        rarity: 'legendary',
    },
    {
        id: 'tonic_swiftness',
        name: 'Tonic of Swiftness',
        description: '+20% CDR for all heroes for 10 waves',
        icon: '💨',
        spriteKey: 'con_tonic_swiftness',
        durationWaves: 10,
        price: 7,
        currency: 'tokens',
        rarity: 'uncommon',
    },
    // ── Special: Mimic Chest (gold-priced, very rare merchant spawn) ──
    {
        id: 'mimic_chest',
        name: 'Mimic Chest',
        description: 'A living chest that grants a free book of your choice',
        icon: '🎁',
        spriteKey: 'con_mimic_chest',
        durationWaves: 1,
        price: 750,
        currency: 'gold',
        rarity: 'legendary',
    },
];
/** Get a consumable definition by ID */
export function getConsumableDef(id) {
    return CONSUMABLE_DEFS.find((c) => c.id === id);
}
//# sourceMappingURL=consumables.js.map